export default __webpack_public_path__ + "static/CharlieText-Regular-e0945e66b87abbc3e2c3985137bec6e3.otf";